<template>
    <div>
        <h2>Lawyer Details</h2>
        <md-table>
          <md-table-row>
            <md-table-head>Name</md-table-head>
            <md-table-head>E-mail</md-table-head>
            <md-table-head>Age</md-table-head>
            <md-table-head>Sex</md-table-head>
            <md-table-head>Years of Exp.</md-table-head>
            <md-table-head>Areas of Expertise</md-table-head>
            <md-table-head>Spoken Languages</md-table-head>
            <md-table-head>Firm Size</md-table-head>
            <md-table-head>Location</md-table-head>
          </md-table-row>
            <md-table-cell md-label="Name">{{ lawyer.profile.firstName }} {{ lawyer.profile.lastName }}</md-table-cell>
            <md-table-cell md-label="E-Mail">{{ lawyer.profile.email }}</md-table-cell>
            <md-table-cell md-label="Age">{{ $moment(lawyer.profile.dob).format('MM/DD/YYYY') }}</md-table-cell>
            <md-table-cell md-label="Sex">{{ lawyer.profile.sex }}</md-table-cell>
            <md-table-cell md-label="Years of Exp.">{{ lawyer.profile.yearsOfExperience }}</md-table-cell>
            <md-table-cell>
                <ul>
                    <li v-for="language in lawyer.profile.areasOfExpertise">
                    {{ language }}
                    </li>
                </ul>
            </md-table-cell>
            <md-table-cell>
                <ul>
                    <li v-for="language in lawyer.profile.spokenLanguages">
                    {{ language }}
                    </li>
                </ul>
            </md-table-cell>
            <md-table-cell>{{ lawyer.profile.firmSize }}</md-table-cell>
            <md-table-cell>{{ lawyer.profile.firmAddress.city }}</md-table-cell>
        </md-table>
    </div>
</template>

<script>
export default {
    name: 'LawyerDetails',
    props: ['lawyer'],
}
</script>